import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

let titleSceneE: any = null;
const E = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneE) {
                    AniContainer.removeScene(titleSceneE);
                    titleSceneE = null;
                }

                titleSceneE = AniContainer.create({
                    triggerElement: '.dpu-detail-E .dpu-E-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneE) {
                    AniContainer.removeScene(titleSceneE);
                    titleSceneE = null;
                }
            };
        }
    }, []);
    return (
        <section className={`dpu-detail-E dpu-detail-section ${styles.dpuDetailE}`}>
            <div className={`dpu-E-box ${textEnter ? 'enter' : ''}`}>
                <p className='title'>{t('secE_title')}</p>
                <p className='desc'>{t('secE_desc')}</p>
            </div>
        </section>
    );
};

export default E;
